import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import HowItWorks from "@/pages/HowItWorks";
import Services from "@/pages/Services";
import Pricing from "@/pages/Pricing";
import Join from "@/pages/Join";
import ForCustomers from "@/pages/ForCustomers";
import Safety from "@/pages/Safety";
import Contact from "@/pages/Contact";
import Grievance from "@/pages/Grievance";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Refund from "@/pages/Refund";
import ProductOrderTerms from "@/pages/ProductOrderTerms";
import MarketplacePolicy from "@/pages/MarketplacePolicy";
import SellerPolicy from "@/pages/SellerPolicy";
import HealthcareNotice from "@/pages/HealthcareNotice";
import Download from "@/pages/Download";
import DeleteAccount from "@/pages/DeleteAccount";
import NotFound from "@/pages/NotFound";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/services" element={<Services />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/join" element={<Join />} />
            <Route path="/for-customers" element={<ForCustomers />} />
            <Route path="/safety" element={<Safety />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/grievance" element={<Grievance />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/refund" element={<Refund />} />
            <Route path="/product-order-terms" element={<ProductOrderTerms />} />
            <Route path="/marketplace-policy" element={<MarketplacePolicy />} />
            <Route path="/seller-policy" element={<SellerPolicy />} />
            <Route path="/healthcare-notice" element={<HealthcareNotice />} />
            <Route path="/download" element={<Download />} />
            <Route path="/delete-account" element={<DeleteAccount />} />
            <Route path="/legal/home" element={<Navigate to="/" replace />} />
            <Route path="/legal/about" element={<Navigate to="/about" replace />} />
            <Route path="/legal/contact" element={<Navigate to="/contact" replace />} />
            <Route path="/legal/privacy" element={<Navigate to="/privacy" replace />} />
            <Route path="/legal/terms" element={<Navigate to="/terms" replace />} />
            <Route path="/legal/refund" element={<Navigate to="/refund" replace />} />
            <Route path="/legal/marketplace" element={<Navigate to="/marketplace-policy" replace />} />
            <Route path="/legal/seller" element={<Navigate to="/seller-policy" replace />} />
            <Route path="/legal/healthcare" element={<Navigate to="/healthcare-notice" replace />} />
            <Route path="/legal/product-order" element={<Navigate to="/product-order-terms" replace />} />
            <Route path="/legal/account-deletion" element={<Navigate to="/delete-account" replace />} />
            <Route path="/recommended-charges" element={<Navigate to="/pricing" replace />} />
            <Route path="/cancellation" element={<Navigate to="/refund" replace />} />
            <Route path="/delivery" element={<Navigate to="/refund" replace />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </HelmetProvider>
  );
}
